import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React, { useContext, useEffect, useState } from 'react';
import { getCurrentSubscriptionForOrganisation, getCurrentSubscriptionStripeDataForOrganisation, getCustomerStripeData, getNumberOfAssignedSeats } from '../../API/Payment/Payment';
import { PricingContext } from '../../Context/Pricing/PricingContext';
import * as Events from '../../Context/Pricing/Events';
import PriceChangeConfirmationForm from './PriceChangeConfirmationForm';
import PriceSelector from './PriceSelector';
import NoAccess from './NoAccess';
import OverflowError, { RoleOverflowError } from './OverflowError';
import SuccessfulChange from './SuccessfulChange';
import { getSubscriptions } from '../../API/Subscription/SubscriptionHelper';

const stripe = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

function PricingForm({ userRole, organization, isAccessedFromRuntime = false }) {

    const { state, dispatch } = useContext(PricingContext);

    const [numberOfAssignedSeats, setNumberOfAssignedSeats] = useState(0);

    async function getData() {
        const { stripeCustomerId, numSeats, _id: organizationId } = organization;
        const [stripeData, currentSubscription, subscriptionStripeData, subscriptions, numberOfAssignedSeatsData] = await Promise.all([
            getCustomerStripeData(organizationId),
            getCurrentSubscriptionForOrganisation(organizationId),
            getCurrentSubscriptionStripeDataForOrganisation(organizationId),
            getSubscriptions(),
            getNumberOfAssignedSeats(organizationId)
        ]);
        debugger;
        dispatch({
            type: Events.ORGANIZATION_STRIPE_DATA_LOADED,
            payload: stripeData
        })
        dispatch({
            type: Events.CURRENT_SUBSCRIPTION_LOADED,
            payload: currentSubscription
        })
        dispatch({
            type: Events.CURRENT_SUBSCRIPTION_STRIPE_DATA_LOADED,
            payload: subscriptionStripeData
        })
        dispatch({
            type: Events.NUM_SEATS_CHANGED,
            payload: numSeats
        })
        dispatch({
            type: Events.SUBSCRIPTIONS_LOADED,
            payload: subscriptions
        })
        debugger
        setNumberOfAssignedSeats(numberOfAssignedSeatsData.numberOfAssignedSeats);
        if (stripeData.invoice_settings && stripeData.invoice_settings.default_payment_method) {
            dispatch({
                type: Events.PAYMENT_METHOD_SELECTED,
                payload: stripeData.invoice_settings.default_payment_method
            })
        }
    }

    useEffect(() => {
        dispatch({
            type: Events.ORGANIZATION_LOADED,
            payload: organization
        })
        getData();
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [state.selectedPlan?.stripeProductId])

    if (state.showSeatOverflowDialog) {
        return (
            <OverflowError
                overflowType={"seats"}
                currentValue={numberOfAssignedSeats}
                allowedValue={state.selectedSubscriptionParameters.maxSeats}
                newPlanName={state.selectedPlan.name} />
        )
    }

    if (state.showProjectOverflowDialog) {
        return (
            <OverflowError
                overflowType={"apps"}
                currentValue={state.numberOfActiveProjects}
                allowedValue={state.selectedSubscriptionParameters.maxApps}
                newPlanName={state.selectedPlan.name} />
        )
    }

    if (state.showRoleOverflowDialog) {
        return (
            <RoleOverflowError
                newPlanName={state.selectedPlan.name} />
        )
    }

    if (state.priceChangeSuccessful) {
        return (
            <SuccessfulChange />
        )
    }

    if (state.selectedPlan && state.selectedPlan.stripeProductId) {

        if (userRole === "Member" || userRole === "App Participant") {
            return (
                <NoAccess />
            )
        }

        return (
            <Elements stripe={stripe}>
                <PriceChangeConfirmationForm isAccessedFromRuntime={true} />
            </Elements>
        )
    }

    return (
        <PriceSelector organization={organization} />
    )
}

export default PricingForm;